import { exigerSession } from '@/lib/garde-session';
import { Outlet, createFileRoute } from '@tanstack/react-router';

/**
 * Layout of `/resultat/$id` and `/resultat/$id/analyse`: it carries the session guard
 * for both, so a visitor without a session is sent to `/login`, which brings them back to the
 * page they asked for once signed in (B5, #13).
 */
export const Route = createFileRoute('/resultat/$id')({
  beforeLoad: ({ location }) => {
    exigerSession(location.href);
  },
  component: Outlet,
});
